import { render, staticRenderFns } from "./closeOrder.vue?vue&type=template&id=f94c18cc&scoped=true"
import script from "./closeOrder.vue?vue&type=script&lang=js"
export * from "./closeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94c18cc",
  null
  
)

export default component.exports